// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"4c99a40d","977":"bbe7ee65"}[chunkId] + ".chunk.js";
};